import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: '0.875rem' },
          success: { iconTheme: { primary: '#38D430', secondary: '#fff' } },
          error: { iconTheme: { primary: '#E53E3E', secondary: '#fff' } },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
);
